await import(`@liferay/language/${Liferay.ThemeDisplay.getLanguageId()}/data-engine-taglib/all.js`);
/**
 * SPDX-FileCopyrightText: (c) 2000 Liferay, Inc. https://liferay.com
 * SPDX-License-Identifier: LGPL-2.1-or-later OR LicenseRef-Liferay-DXP-EULA-2.0.0-2023-06
 */

export const ACTIONS_TYPES = {
	ADD_ACTION: 'ADD_ACTION',
	ADD_CONDITION: 'ADD_CONDITION',
	CHANGE_ACTION: 'CHANGE_ACTION',
	CHANGE_ACTION_AUTOFILL_PARAMETER: 'CHANGE_ACTION_AUTOFILL_PARAMETER',
	CHANGE_ACTION_CALCULATE: 'CHANGE_ACTION_CALCULATE',
	CHANGE_ACTION_TARGET: 'CHANGE_ACTION_TARGET',
	CHANGE_BINARY_OPERATOR: 'CHANGE_BINARY_OPERATOR',
	CHANGE_IDENTIFIER_LEFT: 'CHANGE_IDENTIFIER_LEFT',
	CHANGE_IDENTIFIER_RIGHT: 'CHANGE_IDENTIFIER_RIGHT',
	CHANGE_LOGICAL_OPERATOR: 'CHANGE_LOGICAL_OPERATOR',
	CHANGE_OPERATOR: 'CHANGE_OPERATOR',
	DELETE_ACTION: 'DELETE_ACTION',
	DELETE_CONDITION: 'DELETE_CONDITION',
};
